import React from 'react';
import Addwarehouse from './Addwarehouse';

export default function Serviceability() {
    return <Addwarehouse initialTab="4" />;
}
